import { render, staticRenderFns } from "./SetupQuestions.vue?vue&type=template&id=2a8f34af"
import script from "./SetupQuestions.vue?vue&type=script&lang=js"
export * from "./SetupQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports